// extracted by mini-css-extract-plugin
module.exports = {"customButton":"Button-module--customButton--mN1YD","primary":"Button-module--primary--pg7GC","secondary":"Button-module--secondary--2ce5v"};